import { render, staticRenderFns } from "./reMa-upload.vue?vue&type=template&id=19657c1c&"
import script from "./reMa-upload.vue?vue&type=script&lang=js&"
export * from "./reMa-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports